// 模拟汇率数据（基于USD）
const MOCK_RATES = {
  "USDCNY": 7.2481,  // 美元兑人民币
  "USDJPY": 151.59,  // 美元兑日元
  "USDEUR": 0.9358,  // 美元兑欧元
  "USDGBP": 0.8051,  // 美元兑英镑
  "USDAUD": 1.5559,  // 美元兑澳元
  "USDCAD": 1.3741,  // 美元兑加元
  "USDCHF": 0.9058,  // 美元兑瑞士法郎
  "USDHKD": 7.8235,  // 美元兑港币
  "USDINR": 83.2725, // 美元兑印度卢比
  "USDKRW": 1344.85, // 美元兑韩元
  "USDMYR": 4.7775,  // 美元兑马来西亚林吉特
  "USDSGD": 1.3601,  // 美元兑新加坡元
  "USDTHB": 36.075,  // 美元兑泰铢
  "USDRUB": 92.3545, // 美元兑俄罗斯卢布
  "USDUSD": 1.0000,  // 美元兑美元（基准）
  "USDTWD": 32.15,   // 美元兑新台币
  "USDPHP": 56.45,   // 美元兑菲律宾比索
  "USDIDR": 15725,   // 美元兑印尼盾
  "USDVND": 24515    // 美元兑越南盾
};

const CURRENCY_API_URL = 'https://api.currencylayer.com/live';
const API_KEY = '301f617965ffd78714e1de4c10c67eb7';
const STORAGE_KEY = 'currency_rates';

// 格式化汇率数据，确保所有必需的货币对都存在
const formatRates = (rates) => {
  // 确保所有货币对都是双向的
  const formattedRates = { ...rates };
  
  // 添加反向汇率
  Object.entries(rates).forEach(([pair, rate]) => {
    if (pair.startsWith('USD')) {
      const currency = pair.slice(3); // 获取货币代码
      if (currency !== 'USD') {
        // 添加反向汇率
        formattedRates[`USD${currency}`] = rate;
      }
    }
  });

  // 确保USD对USD的汇率存在
  formattedRates['USDUSD'] = 1.0;

  return formattedRates;
};

export const fetchExchangeRates = async () => {
  try {
    // 检查本地存储
    const storedData = localStorage.getItem(STORAGE_KEY);
    if (storedData) {
      const { timestamp, rates } = JSON.parse(storedData);
      const now = Date.now();
      const hoursSinceUpdate = (now - timestamp) / (1000 * 60 * 60);
      
      // 如果数据不超过24小时，直接返回缓存的数据
      if (hoursSinceUpdate < 24) {
        console.log('使用缓存的汇率数据');
        return formatRates(rates);
      }
    }

    // 尝试获取新数据
    try {
      const response = await fetch(`${CURRENCY_API_URL}?access_key=${API_KEY}&source=USD`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (!data.success) {
        throw new Error(data.error?.info || '获取汇率失败');
      }

      const formattedRates = formatRates(data.quotes);

      // 保存到本地存储
      const storageData = {
        timestamp: Date.now(),
        rates: formattedRates
      };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(storageData));
      console.log('成功获取并保存新的汇率数据');

      return formattedRates;
    } catch (apiError) {
      console.warn('API调用失败，使用模拟数据:', apiError);
      throw apiError; // 继续抛出错误，让外层处理
    }
  } catch (error) {
    console.error('获取汇率失败，使用备用数据:', error);
    
    // 如果有本地存储数据，优先使用本地数据
    const storedData = localStorage.getItem(STORAGE_KEY);
    if (storedData) {
      console.log('使用本地存储的汇率数据');
      const { rates } = JSON.parse(storedData);
      return formatRates(rates);
    }
    
    // 如果没有本地数据，使用模拟数据
    console.log('使用模拟汇率数据');
    const formattedRates = formatRates(MOCK_RATES);
    const storageData = {
      timestamp: Date.now(),
      rates: formattedRates
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(storageData));
    return formattedRates;
  }
}; 